// カルーセルのリンクにマウスを乗せている間は、自動送りを止める。
// クリックしようとしている間にスライドが動き出し、狙ったリンクが流れていくのを防ぐため。
// Swiper 6.2 には autoplay.pauseOnMouseEnter がないため自前で行う。
//
// - マウス操作のときだけ反応する(pointerType で判定)。タッチ画面のタップでは止めない。
//   タップでも互換の mouseenter が発火し、mouseleave が来ないまま止まり続けてしまうため
// - リンクの上にいるときだけ止める。横幅いっぱいのカルーセルで、余白にカーソルがあるだけで止まらないように
// - 自分で止めたときだけ再開する。ほかの理由で止まっている自動送りを勝手に動かさないように
export default function pauseAutoplayOnHover(swiper, container) {
  let pausedByHover = false
  const isOnLink = (element) => element instanceof Element && container.contains(element) && element.closest('a') !== null

  container.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !isOnLink(event.target)) return
    if (!swiper.autoplay.running) return

    swiper.autoplay.stop()
    // スライドの移動中に止めると、Swiper 内部の一時停止の印(autoplay.paused)が残る。
    // そのままタブを離れて戻ると、Swiper のタブ復帰処理が自動送りを勝手に動かし、
    // さらにタイマーが残って start() も効かなくなるため、印も下ろしておく(Swiper 6.2 の内部状態)
    swiper.autoplay.paused = false
    pausedByHover = true
  })

  container.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse' || !pausedByHover) return
    // リンクの中の要素どうし、あるいは隣のリンクへ移っただけなら止めたままにする
    if (isOnLink(event.relatedTarget)) return

    pausedByHover = false
    swiper.autoplay.start()
  })
}
